<script lang="ts">
	import { storeInfoMenu } from '$lib/js/stores'
	import { page } from '$app/stores'
	import { t } from 'svelte-i18n-lingui'
	import { closeSession } from '$lib/js/helpers'
	import { getContextScope } from '$lib/js/helpers/i18n'

	const options: Array<{ link: string; text: string }> = [
			{ link: `customer/account`, text: $t`My account` },
			{ link: `sales/order/history`, text: $t`My orders` },
			{ link: `customer/address`, text: $t`My addresses` },
			{ link: `customer/settings`, text: $t`Configuration` },

			/* 		{ text: $t`My Payment Methods', link: `stripe/customer/paymentmethods` },*/
		],
		scope = getContextScope()

	function closeMenu() {
		$storeInfoMenu = ''
	}

	function logoutUser() {
		closeMenu()
		closeSession({ scope: scope })
	}
</script>

<button class="account-menu" on:mouseleave={() => closeMenu()}>
	<div class="account-menu__inner">
		{#if $page.data.mobile === true}
			<button on:click={() => closeMenu()} class="close">
				<span class="icon icon-cross" />
			</button>
		{/if}

		{#each options as option}
			<a href="/{scope}/{option.link}" on:click={() => closeMenu()}>{option.text}</a>
		{/each}

		<button on:click={() => logoutUser()}>{$t`Close session`}</button>
	</div>
</button>

<style lang="scss">
  .account-menu {
    position: absolute;
    z-index: 99;
    top: 46px;
    right: 0;
    width: 230px;
    text-align: left;
    padding-top: 8px;

    &::after {
      content: '';
      position: absolute;
      right: 60px;
      top: -2px;
      display: block;
      width: 30px;
      height: 30px;
      transform: rotate(45deg);
      background: white;
      border-radius: 5px;

      @media (min-width: 769px) {
        right: 108px;
      }
    }

    &__inner {
      background: white;
      border-radius: 7px;
      padding: 12px 25px;
      box-shadow: 0px 4px 20px 10px rgba(0, 0, 0, 0.12);
      position: relative;

      .close {
        position: absolute;
        right: 5px;
        top: 5px;
        padding: 15px;
      }
    }

    a,
    button {
      display: block;
      color: black;
      padding: 7px 0;

      &:hover {
        color: var(--main);
      }

      span {
        margin-right: 8px;
        font-size: 18px;
      }
    }
  }
</style>
